module.exports = __webpack_public_path__ + "media/bootstrap-icons/view-stacked-46cd2797.svg";